import * as THREE from "three";
const textureLoader = new THREE.TextureLoader();
export const woodMap = textureLoader.load('https://static.deal3dp.com/textures/real.jpg');
export const woodNormal = textureLoader.load('https://static.deal3dp.com/textures/gray.jpg');
export const metalMap = textureLoader.load('https://static.deal3dp.com/textures/metal.jpg');
// обязательно
woodMap.wrapS = woodMap.wrapT = THREE.RepeatWrapping;
woodNormal.wrapS = woodNormal.wrapT = THREE.RepeatWrapping;
// масштаб текстуры (подбираешь)
woodMap.repeat.set(1, 1);
woodNormal.repeat.set(1, 1);
export const matPost = new THREE.MeshStandardMaterial({
    color: '#2ecc71' // зеленый — стойки
});
export const matMauerlat = new THREE.MeshStandardMaterial({
    color: '#bc2ecc' // зеленый — стойки
});
export const matBeam = new THREE.MeshStandardMaterial({
    map: woodMap, // текстура дерева
    color: new THREE.Color('#cf8555'), // оттенок поверх текстуры
    roughness: 0.8,
    metalness: 0.0,
});
export const matBrace = new THREE.MeshStandardMaterial({
    color: '#e74c3c' // красный — раскосы
});
export function createDefaultMaterial(color, offset, repeat) {
    let map = woodMap;
    if (offset || repeat) {
        map = woodMap.clone();
        map.wrapS = map.wrapT = THREE.RepeatWrapping;
        if (offset)
            map.offset.set(offset[0], offset[1]);
        if (repeat)
            map.repeat.set(repeat[0], repeat[1]);
        map.needsUpdate = true; // клон требует явного апдейта
    }
    return new THREE.MeshStandardMaterial({
        map,
        color: color !== undefined ? new THREE.Color(color) : new THREE.Color('#cf8555'),
        roughness: 0.8,
        metalness: 0.0,
    });
}
const PRESETS = {
    wood: { map: woodMap, normalMap: woodNormal, roughnessMap: null, color: '#cf8555', roughness: 0.8, metalness: 0.0 },
    metal: { map: null, normalMap: null, roughnessMap: null, color: '#9aa0a6', roughness: 0.4, metalness: 1.0 },
    matte: { map: null, normalMap: null, roughnessMap: null, color: '#cccccc', roughness: 1.0, metalness: 0.0 },
};
// применяет tiling к текстуре, клонируя её только если нужен свой масштаб
function tiled(tex, offset, repeat) {
    if (!tex)
        return undefined;
    if (!offset && !repeat)
        return tex;
    const t = tex.clone();
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    if (offset)
        t.offset.set(offset[0], offset[1]);
    if (repeat)
        t.repeat.set(repeat[0], repeat[1]);
    t.needsUpdate = true;
    return t;
}
export function createMaterial(options = {}) {
    const { preset = 'wood', color, map, normalMap, roughnessMap, offset, repeat, roughness, metalness, envMapIntensity } = options;
    const base = PRESETS[preset];
    // для каждой карты: опция важнее пресета. undefined = "не трогали, бери пресет". null = "убрать".
    const resolvedMap = map !== undefined ? map : base.map;
    const resolvedNormalMap = normalMap !== undefined ? normalMap : base.normalMap;
    const resolvedRoughnessMap = roughnessMap !== undefined ? roughnessMap : base.roughnessMap;
    return new THREE.MeshStandardMaterial({
        color: new THREE.Color(color !== undefined ? color : base.color),
        roughness: roughness !== undefined ? roughness : base.roughness,
        metalness: metalness !== undefined ? metalness : base.metalness,
        map: tiled(resolvedMap, offset, repeat),
        normalMap: tiled(resolvedNormalMap, offset, repeat),
        roughnessMap: tiled(resolvedRoughnessMap, offset, repeat),
        ...(envMapIntensity !== undefined ? { envMapIntensity } : {}),
    });
}
